// @flow

import { Enum } from '@rover/react-lib/types';
import { Color, DSToken } from '@rover/react-lib/styles';
import { type Props } from './Alert.types';

export class AlertSeverity extends Enum<string> {
  static INFO = new AlertSeverity('info');
  static SUCCESS = new AlertSeverity('success');
  static WARNING = new AlertSeverity('warning');
  static DANGER = new AlertSeverity('danger');

  static isLocked = true;
}

const ALERT_SEVERITY_BACKGROUNDS: { [AlertSeverity]: string } = {
  [AlertSeverity.DANGER]: Color.RED_96,
  [AlertSeverity.WARNING]: Color.YELLOW_96,
  [AlertSeverity.SUCCESS]: Color.GREEN_96,
  [AlertSeverity.INFO]: Color.BLUE_96,
};

const ALERT_SEVERITY_BORDERS: { [AlertSeverity]: string } = {
  [AlertSeverity.DANGER]: DSToken.BORDER_COLOR_ERROR,
  [AlertSeverity.WARNING]: Color.YELLOW_BASE,
  [AlertSeverity.SUCCESS]: Color.GREEN_BASE,
  [AlertSeverity.INFO]: Color.BLUE_BASE,
};

export const getBackgroundColorForSeverity = ({
  severity,
}: {
  severity: $PropertyType<Props, 'severity'>,
}) => {
  const severityBackground = ALERT_SEVERITY_BACKGROUNDS[severity];
  if (severityBackground) return severityBackground;
  return ALERT_SEVERITY_BACKGROUNDS[AlertSeverity.INFO];
};

export const getBorderColorForSeverity = ({
  severity,
}: {
  severity: $PropertyType<Props, 'severity'>,
}) => {
  const severityBorder = ALERT_SEVERITY_BORDERS[severity];
  if (severityBorder) return severityBorder;
  return ALERT_SEVERITY_BORDERS[AlertSeverity.INFO];
};

export const defaultProps = {
  severity: AlertSeverity.INFO,
  onDismiss: undefined,
};



// WEBPACK FOOTER //
// ../react-lib/src/components/notifications/Alert/Alert.common.js